import $ = require('jquery');

export class OptimizeNowWho {
    readonly entryTemplate: string = `
        <div class="who-item">
        <div class="accordion-header-who" id="whoHeading{idx}">
            <a class="accordion-button-who"
                data-toggle="collapse" data-target="#whoCollapse{idx}" href="#whoCollapse{idx}" aria-expanded="false"
            ><div class="float-left whoQuestion"><div class="siteName">{SiteName}</div>{City}</div><div class="caret-button float-right"><span class="accordion-caret"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9l6 6l6-6"/></svg></span></div><div class="clearfix"></div></a>
        </div>
        <div 
            id="whoCollapse{idx}" 
            class="accordion-collapse collapse" 
            aria-labelledby="whoHeading{idx}" 
            data-bs-parent="#{containerId}"
        ><div class="accordion-body accordion-body-who">
        <div class="whoHeader">Principal Investigator</div>
        <strong>{PIName}</strong><br />
        <div class="whoHeader">Coordinator</div>
        <strong>{CoordName}</strong><br />
        <a href="mailto:{CoordEmail}">{CoordEmail}</a><br />
        {CoordPhone}
        </div></div></div>

    `;

    readonly idTemplate: string = 'who_{0}'

    protected who: WHO = {
        Url: '/data/who.json',
        Data: null
    };

    protected $whoContainer: JQuery;

    constructor(protected whoContainerId: string) {
        this.$whoContainer = $(`#${whoContainerId}`);

        if (this.$whoContainer.length == 0) {
            console.warn('container not found');
            return;
        }

        $.get(
            this.who.Url,
            (data: Site[]) => {
                try {
                    ///TODO validate data

                    this.who.Data = data;
                } catch (e) { console.warn(e); return; }

                this.who.Data.forEach((item, idx) => {
                    this.$whoContainer.append(
                        $('<div></div>', { class: "accordion-item py-1" }).html(
                            this.replaceKeys(this.entryTemplate, { idx: idx, SiteName: item.SiteName, City: item.City, PIName: item.PIName, CoordName: item.CoordName, CoordEmail: item.CoordEmail, CoordPhone: item.CoordPhone, containerId: this.whoContainerId })
                        )
                    );
                });
            },
            'json'
        );

    }

    

    private replaceKeys = (template, data) => {
        const pattern = /{\s*(\w+?)\s*}/g; // {property}
        return template.replace(pattern, (_, token) => data[token] || '');
    }



}

interface Site {
    SiteName: string;
    City: string;
    PIName: string;
    CoordName: string;
    CoordEmail: string;
    CoordPhone: string;
}

interface WHO {
    Url: string;
    Data: Site[];
}